import styled from 'styled-components';

const Button = styled.button`
  width: 100px;
  height: 32px;
  margin-left: 10px;
  border: none;
  border-radius: 3px;
  background-color: #daf3a9;
  font-family: 'Menlo';
  font-weight: bold;
  font-size: 16px;
`;

export { Button };


// WEBPACK FOOTER //
// ./src/components/UI/Button.jsx